export const ru = {
  home: {
    welcomeBack: 'С возвращением',
    createRoom: '+ Создать комнату',
    joinByCode: 'Войти по коду',
  },
  onboarding: {
    dialogTitle: 'Как играть в «Сквозь»',
    next: 'Далее',
    back: 'Назад',
    skip: 'Пропустить',
    start: 'Начать играть',
    progressLabel: 'Прогресс обучения',

    howToPlay: 'Как играть?',
    helpIconLabel: 'Как играть',

    step1: {
      title: 'Три буквы — и вперёд',
      body: 'Тебе дают 3 буквы. За 90 секунд назови как можно больше существительных, в которых эти буквы встречаются по порядку — не обязательно подряд.',
      caption: 'Например, для букв к · о · т подходит слово «крот».',
    },

    step2: {
      title: 'Важен порядок, а не соседство',
      body: 'Целевые буквы могут стоять далеко друг от друга — главное, в правильном порядке. Слово — существительное от 4 букв.',
      reasonWrongOrder: 'буквы не по порядку',
      reasonTooShort: 'короче 4 букв',
    },

    step3: {
      title: 'Очки — за буквы вокруг',
      body: 'Очки даёт каждая «лишняя» буква рядом с целевыми. Сами целевые буквы очков не приносят. Буквы внутри слова ценнее, чем по краям.',
      formula: 'Очки = 2×A + 3×B + 3×C + 2×D',
      legend: 'A — до 1-й буквы (×2), B — между 1-й и 2-й (×3), C — между 2-й и 3-й (×3), D — после 3-й (×2).',
      caption: '«Компот» прячет буквы глубоко внутри — и набирает больше.',
    },

    step4: {
      title: 'Бонусы',
      uniqueness: '×2 за уникальность — если это слово в раунде прислал только ты.',
      speed: '+5 / +3 / +1 за скорость — первым троим, кто прислал валидное слово (если бонус включён в настройках комнаты).',
    },

    step5: {
      title: 'Как проходит игра',
      steps: [
        'Создай комнату или войди по коду / ссылке.',
        'Отметься «Готов» — раунд стартует, когда готовы все.',
        '90 секунд вводишь слова: сразу видно ✅ с очками или ❌ с причиной.',
        'По таймеру — результаты раунда.',
        'В матче — серия раундов, победитель по сумме очков.',
      ],
    },

    step6: {
      title: 'Попробуй сам',
      prompt: 'Шаблон — к · о · т. Введи существительное, где эти буквы идут по порядку.',
      placeholder: 'например, компот',
      inputLabel: 'Слово для пробы',
      hints: 'Подсказки: крот · компот · скотч',
      errTooShort: 'Слишком коротко — нужно от 4 букв.',
      errWrongOrder: 'Буквы есть, но не в порядке к · о · т.',
      hintNotInDict: 'Похоже на слово, но его нет в нашем коротком списке. Попробуй другое.',
      playSolo: 'Сыграть соло-тренировку',
      close: 'Закрыть',
    },
  },
  stats: {
    games: 'Игр',
    winrate: 'Побед',
    avgScore: 'Ср. счёт',
    bestWord: 'Лучшее слово',
  },
  recentGames: {
    title: 'Последние игры',
  },
  createRoom: {
    kicker: 'Новая игра',
    title: 'Создать комнату',
    withWho: 'С кем?',
    withFriends: 'С друзьями',
    solo: 'Соло',
    format: 'Формат',
    singleRound: 'Один раунд',
    match: 'Матч',
    rounds: 'Раундов',
    roundDuration: 'Время раунда',
    opponentScore: 'Очки соперников',
    visible: 'Видно',
    hidden: 'Скрыто',
    ctaFriends: 'Создать комнату',
    ctaSolo: 'Начать игру',
  },
} as const;
